export const API_URL = window.location.origin.includes("localhost")
  ? "http://localhost:8000/api"
  : window.location.origin.includes("devweb1")
  ? "https://devapi1.job4u.pk/api"
  : window.location.origin.includes("stgsrv")
  ? "https://stgapi.job4u.pk/api"
  : "https://api.job4u.pk/api";

export const MEDIA_URL = window.location.origin.includes("localhost")
  ? "http://127.0.0.1:8000/storage/"
  : window.location.origin.includes("devweb1")
  ? "https://devapi1.job4u.pk/public/storage/"
  : window.location.origin.includes("stgsrv")
  ? "https://stgapi.job4u.pk/public/storage/"
  : "https://api.job4u.pk/public/storage/";

// export const API_URL = "http://localhost:8000/api";
// export const MEDIA_URL = "http://127.0.0.1:8000/storage/";

// export const API_URL = "https://devapi1.job4u.pk/api";
// export const MEDIA_URL = "https://devapi1.job4u.pk/public/storage/";

// export const API_URL = "https://stgapi.job4u.pk/api";
// export const MEDIA_URL = "https://stgapi.job4u.pk/api/storage/";

// export const API_URL = "https://api.job4u.pk/api";
// export const MEDIA_URL = "https://api.job4u.pk/public/storage/";
